var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#404040",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m235.72 140.01 3.54 9.99h91.09l-3.65-17.98c-13.15-64.78-63.67-115.16-128.72-128.37l-17.98-3.65v90.74c3.14 1.83 41.42 8.93 55.72 49.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.46 291.75c28.63 23.87 65.44 38.25 105.54 38.25 79.47 0 146.35-56.42 161.7-132.02l3.65-17.98h-91.09c-1.21 1.71-13.57 60-74.26 60-15.26 0-29.47-4.58-41.33-12.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.44 206.34c-7.86-11.86-12.44-26.07-12.44-41.34 0-59.28 59.64-74.01 60-74.26v-90.74l-17.98 3.65c-76.43 15.52-132.02 82.69-132.02 161.35 0 40.1 14.38 76.91 38.25 105.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 242h90v210h-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 392h90v60h-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 362h90v90h-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 422h90v30h-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 482h512v30h-512z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.a93a1bbf24a704a4f87627eca4247e27.svg";
export { ForwardRef as ReactComponent };